import path from 'ramda/es/path';

import i18n from 'app/i18n';
import api from '../api';


export const APPS2_REQUEST = 'APPS2_REQUEST';
export const APPS2_SUCCESS = 'APPS2_SUCCESS';
export const APPS2_FAILURE = 'APPS2_FAILURE';
export const APPS2_MAKE_INVALIDATE = 'APPS2_MAKE_INVALIDATE';


export const apps2MakeInvalidate = () => ({
  type: APPS2_MAKE_INVALIDATE,
});

export const apps2Request = () => ({
  type: APPS2_REQUEST,
});

export const apps2Success = data => ({
  type: APPS2_SUCCESS,
  payload: data,
});

export const apps2Failure = payload => ({
  type: APPS2_FAILURE,
  payload,
});


/**
* Запрос данных по приложениям
*/
export const fetchApps = silent => async (dispatch) => {
  if (!silent) dispatch(apps2Request());
  try {
    const res = await api('cabinet/apps2', 'get');
    const subs = path(['data', 'subscriptions'], res);
    const apps = path(['data', 'apps'], res);
    const tariffs = path(['data', 'tariffs'], res);
    const tariffBundles = path(['data', 'tariff_bundles'], res);
    dispatch(apps2Success({
      subs,
      apps,
      tariffs,
      tariffBundles,
    }));
  } catch (error) {
    dispatch(apps2Failure({ err: i18n.t('app:request_apps_failed'), error }));
  }
};
